Organization = require 'models/organization'
PopOver = require 'views/lib/pop-over'
Util = require 'lib/util'
View = require 'view'
templates = require 'views/internal/templates'
track = require 'debug/track'
l = require 'lib/localize'

module.exports = class ChangeOrgVisibilityView extends View
  viewTitleKey: 'select team visibility'

  tagName: 'ul'

  className: 'pop-over-list'

  @setVisibility: (value) ->
    (e) ->
      Util.stop(e)
      track('Organization', 'Changed Visibility')
      @model.setPref('permissionLevel', value)
      PopOver.hide()

  events:
    'click .js-select-members': @setVisibility('private')
    'click .js-select-public': @setVisibility('public')

  render: ->
    data = @model.toJSON({ prefs: true })
    data["permissionLevel_#{@model.get('prefs').permissionLevel}"] = true
    data.publicText = l('org perms.public.text')
    data.privateText = l('org perms.private.text')

    @$el.html(
      templates.fill(
        'change_org_vis',
        data
      )
    )

    @



// WEBPACK FOOTER //
// ./app/scripts/views/organization/change-org-visibility-view.coffee